import styled from 'styled-components'

// import colors from './colors'

const PageLoadingWrapper = styled.div`
  padding: 6rem 0;
  text-align: center;
  animation: pulse 2s ease infinite;

  span {
    font-size: 3rem;
  }

  @keyframes pulse {
    from {
      opacity: .5;
      transform: scale(1);
    }
    10% {
      opacity: 1;
      transform: scale(1.3);
    }
    50% {
      opacity: .8;
      transform: scale(1.1);
    }
    60% {
      opacity: 1;
      transform: scale(1.3);
    }
    to {
      opacity: .5;
      transform: scale(1);
    }
  }
`

export {
  PageLoadingWrapper,
}



// WEBPACK FOOTER //
// ./src/styles/loading.js